// extracted by mini-css-extract-plugin
module.exports = {"card":"FreeChatCard_card__ih97s","btnWrap":"FreeChatCard_btnWrap__Xxdl0","img":"FreeChatCard_img__MnDfY","center":"FreeChatCard_center__XcsOu","text":"FreeChatCard_text__4owIJ"};